import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { tempUrl } from "../../contexts/ContextProvider";
import { AuthContext } from "../../contexts/AuthContext";
import { Loader } from "../../components";
import { Snackbar, Alert } from "@mui/material";
import { Button, Form } from "react-bootstrap";
import { MdLockOutline, MdLogin, MdPersonOutline } from "react-icons/md";

const Login = () => {
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();

  const { error, dispatch } = useContext(AuthContext);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClick = async (e) => {
    setLoadingPage(true);
    e.preventDefault();
    e.stopPropagation();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios.post(`${tempUrl}/auth/login`, {
        username,
        password,
      });
      const findSetting = await axios.post(`${tempUrl}/lastSetting`, {
        kodeCabang: res.data.details.cabang._id,
        id: res.data.details._id,
        token: res.data.details.token,
      });
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data.details,
        setting: findSetting.data,
      });

      navigate("/profilUser");
    } catch (err) {
      setOpen(true);
      dispatch({ type: "LOGIN_FAILURE", payload: err });
    }
    setValidated(true);
    setLoadingPage(false);
  };

  if (loadingPage) {
    return <Loader />;
  }

  return (
    <main className="login-shell">
      <section className="login-card" aria-label="Login pengguna">
        <div className="login-card-accent" />
        <header className="login-header">
          <div className="login-eyebrow">MITRA SISTEM SOLUSI</div>
          <h1>Sistem Informasi Dealer Motor</h1>
        </header>

        <div className="login-intro">
          <h2>Login Pengguna</h2>
        </div>

        <Form noValidate validated={validated} onSubmit={handleClick}>
          <Form.Group className="login-field" controlId="loginUsername">
            <Form.Label>Username</Form.Label>
            <div className="login-input-wrap">
              <MdPersonOutline />
              <Form.Control
                required
                placeholder="USERNAME"
                value={username}
                onChange={(e) => setUsername(e.target.value.toUpperCase())}
              />
            </div>
          </Form.Group>

          <Form.Group className="login-field" controlId="loginPassword">
            <Form.Label>Password</Form.Label>
            <div className="login-input-wrap">
              <MdLockOutline />
              <Form.Control
                required
                type="password"
                placeholder="PASSWORD"
                value={password}
                onChange={(e) => setPassword(e.target.value.toUpperCase())}
              />
            </div>
          </Form.Group>

          <Button className="login-submit" type="submit">
            <MdLogin /> Login
          </Button>
        </Form>
      </section>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Username atau Password salah!
          </Alert>
        </Snackbar>
      )}
    </main>
  );
};

export default Login;

const alertBox = {
  width: "100%",
};
